import { render, staticRenderFns } from "./IgmElisaProcessing.vue?vue&type=template&id=71fc5072&scoped=true&"
import script from "./IgmElisaProcessing.vue?vue&type=script&lang=js&"
export * from "./IgmElisaProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc5072",
  null
  
)

export default component.exports